import { SeoHead } from "@/components/seo/SeoHead";
import { ContactSupportLine } from "@/features/app/components/ContactSupportLine";
import { generatePageMetadata } from "@/lib/seo/metadata";
import { AdminButton } from "@/shared/design-system/admin/AdminButton";
import { AdminLink } from "@/shared/design-system/admin/AdminLink";
import { StatusPage } from "@/shared/layout/StatusPage";
import { InternalLink } from "@/shared/ui/internal-link";

const notFoundMetadata = generatePageMetadata({
  title: "Page not found",
  description: "We couldn't find the Evangelist page you requested.",
  noIndex: true,
});

export function NotFoundPage() {
  return (
    <>
      <SeoHead metadata={notFoundMetadata} />
      <StatusPage
        title="Page not found"
        subtitle="Sorry, we couldn't find the page you're looking for. The link may be broken or the page may have been removed."
        media={<p className="text-5xl font-semibold tracking-tight text-(--color-accent-strong)">404</p>}
        actions={
          <AdminButton asChild>
            <InternalLink analyticsElementId="app-not-found:back-home" href="/">
              Go to homepage
            </InternalLink>
          </AdminButton>
        }
      >
        <div className="mt-6 w-full border-t border-(--app-border-subtle) pt-8">
          <p className="mb-4 text-sm font-semibold text-(--color-text-primary)">Popular pages:</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <AdminLink asChild>
              <InternalLink analyticsElementId="app-not-found:home-link" href="/">
                Home
              </InternalLink>
            </AdminLink>
            <span className="text-(--color-text-tertiary)">•</span>
            <AdminLink asChild>
              <InternalLink analyticsElementId="app-not-found:agencies-link" href="/for-agencies">
                For Agencies
              </InternalLink>
            </AdminLink>
            <span className="text-(--color-text-tertiary)">•</span>
            <AdminLink asChild>
              <InternalLink analyticsElementId="app-not-found:clipping-platforms-link" href="/for-clipping-platforms">
                For Clipping Platforms
              </InternalLink>
            </AdminLink>
          </div>
        </div>

        <ContactSupportLine lead="Still need help?" analyticsElementId="app-not-found:contact-email" />
      </StatusPage>
    </>
  );
}
